import { observable } from "mobx";
import Model from "~/models/Model";

class UiMeet3dGreetingBotDefaultValue extends Model {
  /**
   * @property {string|null}
   */
  @observable key = null;

  /**
   * @property {string|null}
   */
  @observable en = null;

  /**
   * @property {string|null}
   */
  @observable fr = null;
}

export default UiMeet3dGreetingBotDefaultValue;
